module.exports = __webpack_public_path__ + "static/media/Tutorial_icon.bfa96d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/LeftSideMenu/Assests/Tutorial_icon.png
// module id = 7521
// module chunks = 0